import { useState, useCallback } from "react";
import axios from "axios";
import { API } from "@/context/AuthContext";

/**
 * Hook para gestionar la persistencia de `cost_sections` en una oferta.
 *
 * Encapsula:
 *   - estado `sections` (array de secciones CAPEX/OPEX)
 *   - flag `saving`
 *   - `saveSections(newSections)` — envía PUT y actualiza estado local.
 *   - `setSections` para actualizaciones optimistas sin round-trip.
 *
 * @param {string} offerId
 * @param {Array} initialSections
 */
export function useCostSections(offerId, initialSections = []) {
  const [sections, setSections] = useState(initialSections);
  const [saving, setSaving] = useState(false);

  const saveSections = useCallback(async (newSections) => {
    setSaving(true);
    try {
      const { data } = await axios.put(
        `${API}/offers/${offerId}`,
        { cost_sections: newSections }
      );
      setSections(data.cost_sections || []);
      return data;
    } finally {
      setSaving(false);
    }
  }, [offerId]);

  return { sections, setSections, saving, saveSections };
}
